<div class="coupon-main-container">
  <div class="coupon-results">
    <div class="coupon-result-icon">
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.915 7.92969C14.015 7.92969 8.41504 13.5297 8.41504 20.4297C8.41504 27.3297 14.015 32.9297 20.915 32.9297C27.815 32.9297 33.415 27.3297 33.415 20.4297C33.415 13.5297 27.815 7.92969 20.915 7.92969ZM22.79 26.6797L19.04 26.6797L19.04 20.4297L22.79 20.4297L22.79 26.6797ZM20.915 17.9297C19.89 17.9297 19.04 17.0797 19.04 16.0547C19.04 15.0297 19.89 14.1797 20.915 14.1797C21.94 14.1797 22.79 15.0297 22.79 16.0547C22.79 17.0797 21.94 17.9297 20.915 17.9297Z"
          fill="#FBA97F"
        />
      </svg>
    </div>
    <div class="coupon-result-title">{{ noResults.title }}</div>
    <div class="coupon-result-description">{{ noResults.description }}</div>
  </div>
</div>
